import React from 'react';
import { isNumber } from 'lodash';
import { isNumeric } from '../../../util/utils';

const BidPrCalculationMobile = ({ original, ...props }) => {
  const originalValue = React.useMemo(() => {
    return Number(parseFloat(original.bidPricePerCarat).toFixed(2));
  }, [original.bidPricePerCarat]);

  // const updatedValue = React.useMemo(() => {
  //   return original.bidDiscount;
  // }, [original.bidDiscount]);

  const [value, setValue] = React.useState(
    isNumber(original.bidPricePerCarat)
      ? parseFloat(original.bidPricePerCarat).toFixed(2)
      : isNumber(originalValue)
      ? parseFloat(originalValue).toFixed(2)
      : '0.00',
  );

  React.useEffect(() => {
    setValue(parseFloat(original.bidPricePerCarat).toFixed(2));
  }, [original]);

  const handleChange = React.useCallback((e) => {
    e.preventDefault();
    props.showError({ showModal: true });
    const _value = e.target.value;
    if (isNumeric(_value)) setValue(_value);
  }, []);

  const handleBlur = React.useCallback((e) => {
    e.preventDefault();
    props.hideError({ showModal: false });
    const _value = e.target.value;
    isNumeric(_value, true) ? props.handleNewBidBlur(_value, original) : props.handleNewBidBlur(0, original);
  }, []);

  return (
    <div className="tableInput">
      <input value={value} onChange={handleChange} onBlur={handleBlur} />
    </div>
  );
};

export default BidPrCalculationMobile;
